<template lang="pug">
    
    MDashboardWidget( title="Change or add users assigned to audited links" )
      apollo-query(
        v-bind:query="queryUserMany"
        v-bind:update="sortUsers"
        fetch-policy="no-cache"
      )
        template( v-slot="{ result: { loading, error, data } }" )

          div( v-if="loading" ) Loading, please wait...    

          div( v-else-if="error" ) Unexpected error: {{ error }}. Please refresh the page.     

          div( v-else-if="data" )

            p Select a user to assign:
            select( v-model="userId" )
              option( v-bind:value="null" ) Please select
              option( v-for="user in data.userMany" v-bind:value="user.id" ) [{{ user.company.name }}] {{ user.name }}

            div( class="mt-2" v-if="userId" )
              p Please upload a CSV in Moonpull's specific format (one column headed Audit ID and one headed Comment):
              div( class="custom-file" )
                input( id="csv" class="custom-file-input" type="file" v-on:change="updateCsvFile($event)" )
                label( for="csv" class="custom-file-label" ) {{ csvObj === null ? 'Choose file...' : csvObj.name }}
              
              div( class="mt-3 row" )
                div( class="col-12 text-right" )
                  label
                    span I confirm I have authority to bulk update assigned users
                    input( class="mt-1 ml-2" type="checkbox" v-model="confirmed" )

              div( class="row" )
                div( class="col-6" )
                  p( style="color:red;" v-if="fileUploadError !== ''" ) {{ fileUploadError }}
                div( class="col-6 text-right" )
                  button( class="btn btn-primary" v-bind:disabled="csv === null || uploading || ! confirmed" v-on:click="uploadCsv" )
                    MLoadingSpinner( v-if="uploading" )
                    span Assign
          
        p( class="text-success" v-if="success" ) Successfully reassigned all audits from CSV upload!

</template>
<style scoped>
</style>
<script>
import Vue from 'vue'
import gql from 'graphql-tag'
export default Vue.extend({
  data() {
    return{
      userId: null,
      csv: null,
      csvObj: null,
      fileUploadError: '',
      confirmed: false,
      uploading: false,
      success: false,
    }
  },  

  methods: {

    queryUserMany(gql) {
      return gql`
        query UsersMany {
          userMany {
            id
            company {
              name
            }
            name
            title
            email
            isEnabled
            isCompanyOwner
            createdAt
            updatedAt
          }
        }
      `
    },

    sortUsers(data) {
      data.userMany.sort((a, b) => {
        if (a.company.name < b.company.name) return -1
        if (a.company.name > b.company.name) return 1
        return 0
      })
      return data
    },

    updateCsvFile(e) {
      const file = e.target.files[0]
      if (! file.name.endsWith('.csv')) {
        this.fileUploadError = 'Only .CSV files are supported'
        return
      }
      this.csvObj = file
      this.fileUploadError = ''
      const reader = new FileReader()
      reader.addEventListener('load', e => {
        this.csv = e.target.result
      })
      reader.readAsText(file)
    },

    async uploadCsv() {
      this.uploading = true
      await this.$apollo.query({
        query: gql`mutation AssignToUser($csv: String!, $userId: ID!) {
          assignToUser(
            csv: $csv
            userId: $userId
          )
        }`,
        variables: {
          csv: this.csv,
          userId: this.userId
        }
      })
      this.csv = null
      this.csvObj = null
      this.userId = null
      this.uploading = false
      this.confirmed = false
      this.success = true
      setTimeout(() => {
        this.success = false
      }, 5000)
    },

  },

})
</script>